import React, { useContext, useEffect, useState } from "react";
import "./panvel.css";
import { useLayerFunc } from "../Main/layerFunc";
import { GlobalContext } from "../../App";

function NavdeWardProj() {
  const { LayerChange, TileLayerChange, handleOpen } = useLayerFunc();
  const { SetLogout } = useContext(GlobalContext);

  useEffect(() => {
    SetLogout(true);
  }, []);

  return (
    <>
      <details
        className="baseline"
        onToggle={() => handleOpen("Navde_Boundary")}
      >
        <summary>Navde-Ward</summary>
        <div className="baseline-cont">
          <div className="opt-div">
            <input
              value="Navde_Boundary"
              id="Navde_Boundary"
              className="form-check-input check-map"
              type="checkbox"
              onChange={(e) =>
                LayerChange(e.target.value, e.target.id, e.target.checked)
              }
            />
            <label>Boundary</label>
          </div>
          <details id="townD">
            <summary className="townS">Baseline</summary>
            <div className="town-cont">
              <div className="opt-div">
                <input
                  value="Navde_Road_Network"
                  id="Navde_Road_Network"
                  className="form-check-input check-map"
                  type="checkbox"
                  onChange={(e) =>
                    LayerChange(e.target.value, e.target.id, e.target.checked)
                  }
                />
                <label>Road</label>
              </div>
              <div className="opt-div">
                <input
                  value="Navde_Railway_Network"
                  id="Navde_Railway_Network"
                  className="form-check-input check-map"
                  type="checkbox"
                  onChange={(e) =>
                    LayerChange(e.target.value, e.target.id, e.target.checked)
                  }
                />
                <label>Railways</label>
              </div>
              <div className="opt-div">
                <input
                  value="Navde_Mangrove_Swamp"
                  id="Navde_Mangrove_Swamp"
                  className="form-check-input check-map"
                  type="checkbox"
                  onChange={(e) =>
                    LayerChange(e.target.value, e.target.id, e.target.checked)
                  }
                />
                <label>Mangrove Swamp</label>
              </div>
              <div className="opt-div">
                <input
                  value="Navde_Tree"
                  id="Navde_Tree"
                  className="form-check-input check-map"
                  type="checkbox"
                  onChange={(e) =>
                    LayerChange(e.target.value, e.target.id, e.target.checked)
                  }
                />
                <label>Tree</label>
              </div>
              <div className="opt-div">
                <input
                  value="Navde_Water"
                  id="Navde_Water"
                  className="form-check-input check-map"
                  type="checkbox"
                  onChange={(e) =>
                    LayerChange(e.target.value, e.target.id, e.target.checked)
                  }
                />
                <label>Water</label>
              </div>
              <div className="opt-div">
                <input
                  value="Navde_Total_Builtup"
                  id="Navde_Total_Builtup"
                  className="form-check-input check-map"
                  type="checkbox"
                  onChange={(e) =>
                    LayerChange(e.target.value, e.target.id, e.target.checked)
                  }
                />
                <label>Total Builtup</label>
              </div>
            </div>

            <details id="townD">
              <summary className="townS">Town Planning</summary>
              <div
                className="town-cont"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyItems: "right",
                }}
              >
                <div className="opt-div">
                  <input
                    value="Navde_Prabhag"
                    id="Navde_Prabhag"
                    className="form-check-input check-map"
                    type="checkbox"
                    onChange={(e) =>
                      LayerChange(e.target.value, e.target.id, e.target.checked)
                    }
                  />
                  <label>Prabhag</label>
                </div>
                <div className="opt-div">
                  <input
                    value="Navde_Panvel_Jurisdiction"
                    id="Navde_Panvel_Jurisdiction"
                    className="form-check-input check-map"
                    type="checkbox"
                    onChange={(e) =>
                      LayerChange(e.target.value, e.target.id, e.target.checked)
                    }
                  />
                  <label>Jurisdictions</label>
                </div>
                <div className="opt-div">
                  <input
                    value="Navde_Village_Boundary"
                    id="Navde_Village_Boundary"
                    className="form-check-input check-map"
                    type="checkbox"
                    onChange={(e) =>
                      LayerChange(e.target.value, e.target.id, e.target.checked)
                    }
                  />
                  <label>Village Boundary</label>
                </div>
                <div className="opt-div">
                  <input
                    value="Navde_Village_Survey"
                    id="Navde_Village_Survey"
                    className="form-check-input check-map"
                    type="checkbox"
                    onChange={(e) =>
                      LayerChange(e.target.value, e.target.id, e.target.checked)
                    }
                  />
                  <label>Village survey</label>
                </div>
               
              
              </div>
            </details>
          </details>

        <details id="townD">
              <summary className="townS">Builtup Change</summary>
              <div
                className="town-cont"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyItems: "right",
                }}
              >
                <div className="opt-div">
                  <input
                    value="Navde_authorised"
                    id="Navde_authorised"
                    className="form-check-input check-map"
                    type="checkbox"
                    onChange={(e) =>
                      LayerChange(e.target.value, e.target.id, e.target.checked)
                    }
                  />
                  <label>Authorised</label>
                </div>
                <div className="opt-div">
                  <input
                    value="Navde_Unauthorised"
                    id="Navde_Unauthorised"
                    className="form-check-input check-map"
                    type="checkbox"
                    onChange={(e) =>
                      LayerChange(e.target.value, e.target.id, e.target.checked)
                    }
                  />
                  <label>Unauthorised</label>
                </div>
                <div className="opt-div">
                  <input
                    value="Navde_Other_Authority"
                    id="Navde_Other_Authority"
                    className="form-check-input check-map"
                    type="checkbox"
                    onChange={(e) =>
                      LayerChange(e.target.value, e.target.id, e.target.checked)
                    }
                  />
                  <label>Other Authority</label>
                </div>
                 <div className="opt-div">
                  <input
                    value="Navde_Pending"
                    id="Navde_Pending"
                    className="form-check-input check-map"
                    type="checkbox"
                    onChange={(e) =>
                      LayerChange(e.target.value, e.target.id, e.target.checked)
                    }
                  />
                  <label> Pending </label>
                </div>
                 <div className="opt-div">
                  <input
                    value="Navde_shed"
                    id="Navde_shed"
                    className="form-check-input check-map"
                    type="checkbox"
                    onChange={(e) =>
                      LayerChange(e.target.value, e.target.id, e.target.checked)
                    }
                  />
                  <label> Shed </label>
                </div>
                <div className="opt-div">
                  <input
                    value="Navde_total_builtup_jan2023"
                    id="Navde_total_builtup_jan2023"
                    className="form-check-input check-map"
                    type="checkbox"
                    onChange={(e) =>
                      LayerChange(e.target.value, e.target.id, e.target.checked)
                    }
                  />
                  <label>Total builtup jan2023</label>
                </div>
              </div>
            </details>

          <details id="townD">
            <summary className="townS">Images</summary>
            <div className="town-cont mb-3">
              <div className="opt-div">
                <input
                  value="Jan_2023"
                  id="Navde_Boundary"
                  onChange={(e) =>
                    TileLayerChange(
                      e.target.value,
                      e.target.id,
                      "Jan 2023",
                      e.target.checked
                    )
                  }
                  className="form-check-input check-map"
                  type="checkbox"
                />
                <label>Jan 2023</label>
              </div>
              <div className="opt-div">
                <input
                  value="March_2025"
                  id="Navde_Boundary"
                  onChange={(e) =>
                    TileLayerChange(
                      e.target.value,
                      e.target.id,
                      "March 2025",
                      e.target.checked
                    )
                  }
                  className="form-check-input check-map"
                  type="checkbox"
                />
                <label>March 2025</label>
              </div>
            </div>
          </details>
        </div>
      </details>
    </>
  );
}

export default NavdeWardProj;
